(function initializeCateringOrderRedesign() {
  'use strict';

  const OPERATIONS_ADDON_HANDLES = new Set([
    'bbq-brisket',
    'bbq-chicken',
    'bbq-czech-sausage',
    'bbq-jalapeno-sausage',
    'bbq-ham',
    'bbq-turkey-breast',
    'bbq-pork-ribs',
    'bbq-bbq-sides',
    'bbq-white-bread-loaf',
    'bbq-goode-s-original-barbeque-sauce',
    'bbq-jalapeno-cheese-bread',
    'bbq-onion-bun',
    'bbq-brazos-bottom-pecan-pie',
    'bbq-chocolate-cream-pie',
    'bbq-iced-tea',
    'bbq-fresh-squeezed-lemonade',
  ]);
  const SIDE_ITEM_ORDER = [
    'Potato Salad',
    'Jalapeño Pinto Beans',
    'Austin Baked Beans',
    'Cole Slaw',
    'Jambalaya Texana',
    'Southwest Green Beans',
    'Macaroni & Cheese',
  ];

  function ready(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  }

  ready(() => {
    const rules = window.CateringPackRules;
    const stateApi = window.CateringOrderState;
    const templates = window.CateringOrderTemplates;
    if (!rules || !stateApi || !templates) return;
    document.querySelectorAll('[data-catering-order-redesign]').forEach((root) => setup(root, rules, stateApi, templates));
  });

  function setup(root, rules, stateApi, templates) {
    if (root.dataset.orderInitialized === 'true') return;
    root.dataset.orderInitialized = 'true';

    const catalogNode = root.querySelector('[data-order-catalog]');
    const contentNode = root.querySelector('[data-order-content]');
    const mainNode = root.querySelector('[data-order-main]');
    const railNode = root.querySelector('[data-order-rail]');
    const railSurfaceNode = railNode.closest('.catering-order-redesign__rail');
    const drawerNode = root.querySelector('[data-order-drawer]');
    const drawerContentNode = root.querySelector('[data-order-drawer-content]');
    const feedbackNode = root.querySelector('[data-order-feedback]');
    const breadcrumbsNode = root.querySelector('[data-order-breadcrumbs]');
    const eyebrowNode = root.querySelector('[data-order-eyebrow]');
    const headingNode = root.querySelector('[data-order-heading]');
    const ledeNode = root.querySelector('[data-order-lede]');
    const replaceDialog = root.querySelector('[data-order-replace-dialog]');
    const replaceItemsNode = root.querySelector('[data-order-replace-items]');
    const bookingDialog = root.querySelector('[data-order-booking-dialog], [data-catering-booking-dialog]');
    const incompleteDialog = root.querySelector('[data-order-incomplete-dialog]');
    const incompleteEyebrowNode = root.querySelector('[data-order-incomplete-eyebrow]');
    const incompleteHeadingNode = root.querySelector('[data-order-incomplete-heading]');
    const incompleteBodyNode = root.querySelector('[data-order-incomplete-body]');
    const mobileSummaryNode = root.querySelector('.catering-order-redesign__mobile-summary');
    const mobileSummaryControl = mobileSummaryNode?.querySelector('[data-action="open-order-drawer"]');
    const mobileStageActionsNode = root.querySelector('[data-order-mobile-stage-actions]');
    const mobileSubtotalNode = root.querySelector('[data-order-mobile-subtotal]');
    const mobileCountNode = root.querySelector('[data-order-mobile-count]');
    const catalog = JSON.parse(catalogNode.textContent || '{"concepts":[]}');
    const copy = {
      catalogPrimaryCta: 'Start your order',
      catalogAlaCarteCta: 'Shop A la carte',
      viewMenusCta: 'View menus',
      bookNowCta: 'Book now',
      configureHeading: 'Build your party pack',
      configureBody: 'Choose your guest count, then assign every included meat and side.',
      addonsHeading: 'Add-ons',
      addonsBody: 'Choose any extras for your gathering.',
      alaCarteHeading: 'A La Carte',
      alaCarteBody: 'Prefer to customize your order for a hungrier herd? Build an a la carte order exactly how you\'d like by the pound, rack, pint, quart or gallon.',
      configureCta: 'Add extras',
      updateOrderCta: 'Update order',
      deliveryCta: 'Review delivery options',
      incompleteEyebrow: 'Hey there!',
      incompleteHeading: 'Your party pack is not complete',
      incompleteBody: 'Finish every required selection before continuing.',
      incompleteReturnCta: 'Return to choices',
      ...(catalog.copy || {}),
    };
    const concepts = (catalog.concepts || []).map(normalizeConcept).filter((concept) => concept.handle && concept.pack?.variantId);
    const currency = root.dataset.currency || 'USD';
    const initialCopy = {
      eyebrow: eyebrowNode.textContent,
      heading: headingNode.textContent,
      lede: ledeNode.textContent,
    };
    let pendingReplace = null;
    let pendingInvalidGroup = '';
    let feedbackTimer = null;
    let alertTimer = null;
    let mobilePanelState = 'collapsed';
    let mobilePanelCloseTimer = null;
    let drawerGesture = null;
    let drawerDragged = false;

    const parameters = new URL(window.location.href).searchParams;
    const state = {
      stage: stateApi.normalizeStage(parameters.get('stage')),
      menu: parameters.get('menu') || '',
      cart: { items: [], item_count: 0, total_price: 0 },
      draft: null,
      addonSelections: {},
      categorySelections: {
        meat: { itemKey: '', variantId: '', quantity: 1 },
        side: { itemKey: '', variantId: '', quantity: 1 },
      },
      alerts: {},
      busy: false,
    };

    function normalizeConcept(concept) {
      const normalizedRule = rules.normalizeRule(concept.pack?.rule);
      const aLaCarteProducts = (Array.isArray(concept.aLaCarteProducts) ? concept.aLaCarteProducts : [])
        .filter((product) => product
          && product.available !== false
          && product.variantId
          && OPERATIONS_ADDON_HANDLES.has(String(product.handle || '')))
        .map((product) => {
          const optionNames = (Array.isArray(product.optionNames) ? product.optionNames : [])
            .map((name) => String(name || '').trim())
            .filter(Boolean);
          const variants = (Array.isArray(product.variants) ? product.variants : [])
            .filter((variant) => variant && variant.id && variant.available !== false)
            .map((variant) => ({
              ...variant,
              id: String(variant.id),
              price: Number(variant.price || 0),
              optionValues: (Array.isArray(variant.optionValues) ? variant.optionValues : [])
                .map((value) => String(value || '').trim()),
            }));
          const primaryVariant = variants.find((variant) => variant.id === String(product.variantId)) || variants[0] || {
            id: String(product.variantId),
            title: product.title,
            price: Number(product.price || 0),
            measure: product.measure || '',
            optionValues: [],
          };
          return {
            ...product,
            groupKey: normalizeProductBand(product.band, product.title),
            optionNames,
            variants,
            variantId: primaryVariant.id,
            price: primaryVariant.price,
            measure: primaryVariant.measure,
          };
        });
      const choiceOptions = (Array.isArray(concept.pack?.choiceOptions) ? concept.pack.choiceOptions : [])
        .filter((option) => option && option.enabled !== false && option.label)
        .map((option) => ({ ...option, groupKey: String(option.groupKey || '').toLowerCase() }));
      const choiceGroups = normalizeChoiceGroups(
        concept.pack?.choiceGroups || [],
        choiceOptions,
        catalog.placeholderImage,
        aLaCarteProducts,
      );
      return {
        ...concept,
        presentation: concept.presentation || {},
        pack: { ...concept.pack, rule: normalizedRule, choiceGroups, choiceOptions },
        aLaCarteProducts,
      };
    }

    function normalizeChoiceGroups(groups, choiceOptions, placeholderImage, products) {
      return (Array.isArray(groups) ? groups : []).map((group, index) => {
        const label = String(group.name || group.label || `Choice ${index + 1}`);
        const explicitKey = String(group.key || '').toLowerCase();
        const inferredKey = explicitKey || (/meat|protein/.test(label.toLowerCase()) ? 'meat' : (/side/.test(label.toLowerCase()) ? 'side' : slug(label)));
        const values = (group.options || group.values || []).map((option) => typeof option === 'string' ? option : option.name || option.label || option.value).filter(Boolean);
        const optionDetails = {};
        values.forEach((value) => {
          const record = choiceOptions.find((option) => option.groupKey === inferredKey && option.label.toLowerCase() === String(value).toLowerCase());
          const product = record?.linkedProductHandle
            ? products.find((candidate) => candidate.handle === record.linkedProductHandle)
            : products.find((candidate) => candidate.title.toLowerCase().includes(String(value).toLowerCase()));
          optionDetails[value] = {
            key: record?.key || slug(value),
            image: record?.image || product?.image || placeholderImage,
            imageAlt: record?.imageAlt || value,
            description: record?.description || product?.description || '',
          };
        });
        return { key: inferredKey, label, options: values, optionDetails, placeholderImage };
      }).filter((group) => group.options.length && (group.key === 'meat' || group.key === 'side'));
    }

    function normalizeProductBand(value, title) {
      const input = `${value || ''} ${title || ''}`.toLowerCase().replaceAll('-', ' ').replaceAll('_', ' ');
      if (/dessert|sweet|cookie|brownie|pie/.test(input)) return 'dessert';
      if (/drink|beverage|tea|water|soda|coke/.test(input)) return 'drink';
      if (/side|bean|slaw|salad|jambalaya|macaroni/.test(input)) return 'side';
      if (/meat|brisket|chicken|sausage|ham|turkey|rib/.test(input)) return 'meat';
      return 'other';
    }

    function slug(value) {
      return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    }

    function money(cents) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(Number(cents || 0) / 100);
    }

    function conceptByHandle(handle) {
      return concepts.find((concept) => concept.handle === handle) || null;
    }

    function currentConcept() {
      return conceptByHandle(state.menu) || concepts.find((concept) => concept.onlineOrderingEnabled) || concepts[0] || null;
    }

    function packLine() {
      return state.cart.items.find(stateApi.isPackLine) || null;
    }

    function cartConcept() {
      const line = state.cart.items.find((item) => stateApi.lineConcept(item));
      return line ? stateApi.lineConcept(line) : '';
    }

    function lineByVariant() {
      return new Map(state.cart.items.map((item) => [String(item.variant_id), item]));
    }

    function orderedValues(values, preferred) {
      const comparisonKey = (value) => String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
      const normalized = new Map(values.map((value) => [comparisonKey(value), value]));
      return [
        ...preferred.map((value) => normalized.get(comparisonKey(value))).filter(Boolean),
        ...values.filter((value) => !preferred.some((preferredValue) => comparisonKey(preferredValue) === comparisonKey(value))),
      ];
    }

    function variantOption(variant, index) {
      return String(variant?.optionValues?.[index] || '').trim();
    }

    function virtualProduct(product, title, variants, optionIndex, suffix) {
      const filteredVariants = variants.filter(Boolean);
      const rawOptionLabel = String(product.optionNames?.[optionIndex] || '').trim();
      const optionLabel = rawOptionLabel && !/^title$/i.test(rawOptionLabel)
        ? rawOptionLabel
        : 'Type';
      return {
        ...product,
        key: suffix ? `${product.key}::${slug(suffix)}` : product.key,
        sourceKey: product.key,
        title,
        variants: filteredVariants,
        sizeOptionIndex: optionIndex,
        optionLabel,
        requiresSize: filteredVariants.length > 1,
      };
    }

    function buildVirtualProducts(concept) {
      return (concept?.aLaCarteProducts || []).flatMap((product) => {
        if (product.handle === 'bbq-bbq-sides') {
          const values = orderedValues(
            Array.from(new Set(product.variants.map((variant) => variantOption(variant, 0)).filter(Boolean))),
            SIDE_ITEM_ORDER,
          );
          return values.map((value) => virtualProduct(
            product,
            value,
            product.variants.filter((variant) => variantOption(variant, 0) === value),
            1,
            value,
          ));
        }
        return [virtualProduct(product, product.title, product.variants, 0, '')];
      });
    }

    function sizeLabel(product, variant) {
      const optionValue = variantOption(variant, product.sizeOptionIndex);
      if (optionValue) return optionValue;
      return /^default title$/i.test(String(variant.title || '')) ? product.measure || 'Standard' : variant.title;
    }

    function resolvedVirtualProducts(concept) {
      return buildVirtualProducts(concept).filter((product) => product.variants.length).map((product) => {
        const selection = state.addonSelections[product.key] || {
          variantId: product.requiresSize ? '' : String(product.variants[0]?.id || ''),
          quantity: 1,
        };
        const selectedVariant = product.variants.find((variant) => variant.id === String(selection.variantId)) || null;
        if (!product.requiresSize && !selectedVariant && product.variants[0]) selection.variantId = product.variants[0].id;
        selection.quantity = Math.max(1, Number.parseInt(selection.quantity, 10) || 1);
        state.addonSelections[product.key] = selection;
        const resolvedVariant = product.variants.find((variant) => variant.id === String(selection.variantId)) || null;
        // Virtual side cards use their flavor's first variant until a size is selected.
        const displayVariant = resolvedVariant || product.variants[0] || null;
        return {
          ...product,
          variantId: resolvedVariant?.id || '',
          selectedVariant: resolvedVariant,
          quantity: selection.quantity,
          image: displayVariant?.image || product.image || '',
          price: resolvedVariant?.price ?? Math.min(...product.variants.map((variant) => Number(variant.price || 0))),
          measure: resolvedVariant?.measure || product.measure || '',
          sizeOptions: product.variants.map((variant) => ({
            id: variant.id,
            label: sizeLabel(product, variant),
            price: variant.price,
          })),
        };
      });
    }

    function categorySelector(concept, key, products) {
      const items = products.filter((product) => product.groupKey === key);
      const selection = state.categorySelections[key];
      const item = items.find((candidate) => candidate.key === selection.itemKey) || null;
      if (!item) {
        selection.itemKey = '';
        selection.variantId = '';
      } else if (!item.variants.some((variant) => variant.id === String(selection.variantId))) {
        selection.variantId = '';
      }
      selection.quantity = Math.max(1, Number.parseInt(selection.quantity, 10) || 1);
      const variant = item?.variants.find((candidate) => candidate.id === String(selection.variantId)) || null;
      return {
        key,
        label: key === 'meat' ? 'Meats' : 'Sides',
        itemLabel: key === 'meat' ? 'Choose a meat' : 'Choose a side',
        items,
        itemKey: selection.itemKey,
        variantId: selection.variantId,
        quantity: selection.quantity,
        variant,
      };
    }

    function createDraft(concept, item) {
      const guests = rules.normalizeGuestCount(
        Number(item?.properties?.[stateApi.PUBLIC_PROPERTIES.guestCount] || item?.quantity || concept.pack.rule.defaultGuests),
        concept.pack.rule,
      );
      const savedDisposableWare = item?.properties?.[stateApi.PUBLIC_PROPERTIES.includeDisposableWare];
      const draft = {
        concept: concept.handle,
        guests,
        includeDisposableWare: savedDisposableWare == null || String(savedDisposableWare).toLowerCase() !== 'no',
        groups: {},
      };
      concept.pack.choiceGroups.forEach((group) => {
        const propertyPrefix = group.key === 'meat' ? 'Meat' : 'Side';
        const selected = stateApi.parseChoiceList(
          item?.properties?.[`${propertyPrefix} choices`]
          || item?.properties?.[`${propertyPrefix} Choice`]
          || item?.properties?.[`${propertyPrefix} Choices`],
        ).filter((name) => group.options.includes(name));
        const savedPortions = item?.properties?.[`${propertyPrefix} portions`]
          || item?.properties?.[`${propertyPrefix} Choice Portions`]
          || '';
        draft.groups[group.key] = {
          selected,
          allocations: stateApi.parsePortions(savedPortions),
          manuallyAdjusted: Boolean(savedPortions),
        };
      });
      resizeDraft(draft, concept, guests);
      return draft;
    }

    function ensureDraft(concept) {
      if (state.draft && state.draft.concept === concept.handle) return state.draft;
      const item = packLine();
      const itemMatches = item && (stateApi.lineConcept(item) === concept.handle || String(item.variant_id) === String(concept.pack.variantId));
      state.draft = createDraft(concept, itemMatches ? item : null);
      return state.draft;
    }

    function resizeDraft(draft, concept, requestedGuests) {
      draft.guests = rules.normalizeGuestCount(requestedGuests, concept.pack.rule);
      const requirements = rules.calculatePackRequirements(draft.guests, concept.pack.rule);
      concept.pack.choiceGroups.forEach((group) => {
        const groupState = draft.groups[group.key] || { selected: [], allocations: {}, manuallyAdjusted: false };
        const measure = group.key === 'meat' ? requirements.meat : requirements.sides;
        groupState.selected = groupState.selected.filter((name) => group.options.includes(name)).slice(0, measure.maximumSelections);
        groupState.allocations = rules.resizeAllocations(
          groupState.selected,
          measure.quantity,
          measure.step,
          measure.minimumPerOption,
          groupState.allocations,
        );
        draft.groups[group.key] = groupState;
      });
      return draft;
    }

    function groupContext(concept, group, requirements) {
      const draft = ensureDraft(concept);
      const groupState = draft.groups[group.key];
      const measure = group.key === 'meat' ? requirements.meat : requirements.sides;
      const validation = rules.validateAllocations(
        groupState.selected,
        groupState.allocations,
        measure.quantity,
        measure.step,
        measure.minimumPerOption,
        measure.maximumSelections,
      );
      const summary = groupState.selected.map((name) => `${groupState.allocations[name] || 0} ${measure.unit} ${name}`).join(', ');
      return {
        ...group,
        selected: groupState.selected,
        allocations: groupState.allocations,
        total: measure.quantity,
        unit: measure.unit,
        step: measure.step,
        minimum: measure.minimumPerOption,
        maximumSelections: measure.maximumSelections,
        optionLabel: group.key === 'meat' ? 'meats' : 'sides',
        totalLabel: group.key === 'side' ? rules.formatSideQuantity(measure) : `${measure.quantity} ${measure.unit}`,
        valid: validation.valid,
        summary,
        alert: state.alerts[group.key] || '',
        optionDetails: group.optionDetails,
        placeholderImage: group.placeholderImage,
      };
    }

    function checkoutState() {
      const itemPack = packLine();
      const orderConcept = conceptByHandle(cartConcept()) || currentConcept();
      const subtotal = orderConcept ? stateApi.aLaCarteSubtotal(state.cart, orderConcept.handle) : 0;
      const minimum = orderConcept ? Number(orderConcept.aLaCarteMinimumCents || 0) : 0;
      const progress = stateApi.minimumProgress(subtotal, minimum);
      const empty = !state.cart.items.length;
      return {
        allowed: !empty && (Boolean(itemPack) || progress.satisfied),
        message: empty ? 'Add an item to continue.' : `${money(progress.remaining)} more in A la carte items is required.`,
      };
    }

    function render() {
      const concept = currentConcept();
      if (!state.menu && concept) state.menu = concept.handle;
      if ((state.stage === 'configure' || state.stage === 'ala-carte' || state.stage === 'addons') && !concept) state.stage = 'catalog';
      root.dataset.stage = state.stage;
      const isCatalog = state.stage === 'catalog';
      railSurfaceNode.hidden = isCatalog;
      mobileSummaryNode.hidden = isCatalog;
      root.classList.toggle('is-busy', state.busy);
      updateMasthead(concept);
      breadcrumbsNode.innerHTML = templates.breadcrumbs({ stage: state.stage, concept });

      const checkout = checkoutState();
      const common = {
        money,
        rules,
        stateApi,
        cart: state.cart,
        copy,
        placeholderImage: catalog.placeholderImage || '',
        checkoutAllowed: checkout.allowed,
        checkoutMessage: checkout.message,
        checkoutUrl: root.dataset.checkoutUrl,
      };
      let draftPack = null;
      if (state.stage === 'configure' && concept) {
        const draft = ensureDraft(concept);
        const requirements = rules.calculatePackRequirements(draft.guests, concept.pack.rule);
        const groups = concept.pack.choiceGroups.map((group) => groupContext(concept, group, requirements));
        draftPack = {
          concept,
          guests: draft.guests,
          requirements,
          groups,
          total: concept.pack.pricePerPerson * draft.guests,
          includeDisposableWare: draft.includeDisposableWare,
        };
        contentNode.innerHTML = templates.configurator({
          ...common,
          concept,
          rule: concept.pack.rule,
          guests: draft.guests,
          includeDisposableWare: draft.includeDisposableWare,
          requirements,
          groups,
        });
      } else if ((state.stage === 'ala-carte' || state.stage === 'addons') && concept) {
        const alaSubtotal = stateApi.aLaCarteSubtotal(state.cart, concept.handle);
        const minimumCents = Number(concept.aLaCarteMinimumCents || 0);
        const products = resolvedVirtualProducts(concept);
        const displayConcept = { ...concept, aLaCarteProducts: products };
        contentNode.innerHTML = templates.alaCarte({
          ...common,
          stage: state.stage,
          concept: displayConcept,
          categorySelectors: [
            categorySelector(concept, 'meat', products),
            categorySelector(concept, 'side', products),
          ],
          linesByVariant: lineByVariant(),
          packLine: packLine(),
          alaSubtotal,
          minimumCents,
          minimumProgress: stateApi.minimumProgress(alaSubtotal, minimumCents),
        });
      } else {
        contentNode.innerHTML = templates.catalog({ ...common, concepts, menuDestination: catalog.menuDestination });
      }

      const summary = templates.orderSummary({
        ...common,
        stage: state.stage,
        concept,
        draftPack,
        packLine: packLine(),
        panelEyebrow: root.querySelector('[data-order-drawer] h2')?.textContent || 'Current order',
        entreeServes: stateApi.entreeServes(state.cart),
      });
      const railSummary = templates.orderSummary({
        ...common,
        stage: state.stage,
        concept,
        draftPack: null,
        packLine: packLine(),
        panelEyebrow: root.querySelector('[data-order-drawer] h2')?.textContent || 'Current order',
        entreeServes: stateApi.entreeServes(state.cart),
      });
      railNode.innerHTML = isCatalog ? '' : railSummary;
      drawerContentNode.innerHTML = summary;
      const mobileStageActions = templates.stageActions({
        ...common,
        stage: state.stage,
        concept,
        draftPack,
        packLine: packLine(),
      }, { mobile: true });
      if (mobileStageActionsNode) mobileStageActionsNode.innerHTML = mobileStageActions;
      root.classList.toggle('has-mobile-stage-actions', Boolean(mobileStageActions));
      mobileSubtotalNode.textContent = money(draftPack ? draftPack.total : (state.cart.total_price || 0));
      mobileCountNode.textContent = draftPack
        ? `${draftPack.guests} guests`
        : `${state.cart.item_count || 0} ${state.cart.item_count === 1 ? 'item' : 'items'}`;
      syncHeaderCartCount();
      window.requestAnimationFrame(syncMobileSummaryVisibility);
    }

    function syncMobileSummaryVisibility() {
      if (!mobileSummaryNode) return;
      mobileSummaryNode.classList.remove('is-deferred');
      mobileSummaryNode.removeAttribute('aria-hidden');
    }

    function isMobileViewport() {
      return window.matchMedia('(max-width: 1024px)').matches;
    }

    function syncMobilePanelControls() {
      const expanded = mobilePanelState !== 'collapsed';
      mobileSummaryControl?.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    function setMobilePanelState(nextState, options = {}) {
      if (!drawerNode || !isMobileViewport()) return;
      const next = ['collapsed', 'half-open', 'expanded'].includes(nextState) ? nextState : 'collapsed';
      if (mobilePanelCloseTimer) {
        window.clearTimeout(mobilePanelCloseTimer);
        mobilePanelCloseTimer = null;
      }

      mobilePanelState = next;
      syncMobilePanelControls();

      if (next === 'collapsed') {
        drawerNode.dataset.mobilePanelState = 'collapsed';
        if (!drawerNode.open) return;
        drawerNode.classList.add('is-closing');
        mobilePanelCloseTimer = window.setTimeout(() => {
          if (drawerNode.open) drawerNode.close();
          drawerNode.classList.remove('is-closing');
          mobilePanelCloseTimer = null;
          if (options.returnFocus) mobileSummaryControl?.focus();
        }, 220);
        return;
      }

      if (!drawerNode.open) drawerNode.showModal();
      drawerNode.classList.remove('is-closing');
      drawerNode.dataset.mobilePanelState = next;
      if (options.focus !== false) {
        window.requestAnimationFrame(() => drawerNode.querySelector('[data-action="collapse-order-drawer"]')?.focus());
      }
    }

    function beginDrawerGesture(event) {
      if (!drawerNode.open || !isMobileViewport()) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      const handle = event.target.closest('[data-order-drawer-handle]');
      const body = event.target.closest('[data-order-drawer-content]');
      const interactiveTarget = event.target.closest('button, a, input, select, textarea, label');
      if (!handle && (!body || interactiveTarget || body.scrollTop > 0)) return;
      drawerGesture = { startY: event.clientY, state: mobilePanelState, pointerId: event.pointerId, target: handle || body };
      drawerDragged = false;
      drawerGesture.target.setPointerCapture?.(event.pointerId);
    }

    function moveDrawerGesture(event) {
      if (!drawerGesture || event.pointerId !== drawerGesture.pointerId) return;
      if (Math.abs(event.clientY - drawerGesture.startY) > 10) drawerDragged = true;
    }

    function finishDrawerGesture(event) {
      if (!drawerGesture || event.pointerId !== drawerGesture.pointerId) return;
      const gesture = drawerGesture;
      drawerGesture = null;
      gesture.target.releasePointerCapture?.(event.pointerId);
      const deltaY = event.clientY - gesture.startY;
      if (Math.abs(deltaY) < 56) return;
      if (deltaY < 0) {
        setMobilePanelState('expanded', { focus: false });
      } else if (gesture.state === 'expanded') {
        setMobilePanelState('half-open', { focus: false });
      } else {
        setMobilePanelState('collapsed', { returnFocus: true });
      }
    }

    function updateMasthead(concept) {
      if (state.stage === 'catalog') {
        eyebrowNode.textContent = initialCopy.eyebrow;
        headingNode.textContent = initialCopy.heading;
        ledeNode.textContent = initialCopy.lede;
        return;
      }
      eyebrowNode.textContent = concept?.label || initialCopy.eyebrow;
      if (state.stage === 'configure') {
        headingNode.textContent = copy.configureHeading || `Build your ${concept.pack.title}`;
        ledeNode.textContent = copy.configureBody || 'Set the guest count, then allocate every included meat and side.';
      } else {
        headingNode.textContent = state.stage === 'addons' ? copy.addonsHeading : copy.alaCarteHeading;
        ledeNode.textContent = state.stage === 'addons'
          ? copy.addonsBody
          : copy.alaCarteBody;
      }
    }

    function syncHeaderCartCount() {
      const link = document.querySelector('.goode-header__cart-link');
      if (!link) return;
      let count = link.querySelector('.goode-header__cart-count');
      if (state.cart.item_count > 0 && !count) {
        count = document.createElement('span');
        count.className = 'goode-header__cart-count goode-type goode-type--eyebrow';
        link.prepend(count);
      }
      if (count) {
        count.textContent = String(state.cart.item_count || 0);
        count.hidden = state.cart.item_count === 0;
      }
    }

    function syncUrl(push) {
      const url = new URL(window.location.href);
      const stage = state.stage === 'catalog' ? 'entrees' : state.stage;
      url.searchParams.set('stage', stage);
      if (state.menu) url.searchParams.set('menu', state.menu);
      else url.searchParams.delete('menu');
      window.history[push ? 'pushState' : 'replaceState']({ stage, menu: state.menu }, '', url);
    }

    function focusStageStart() {
      window.requestAnimationFrame(() => {
        const headerHeight = document.querySelector('.goode-header')?.getBoundingClientRect().height || 0;
        const top = root.getBoundingClientRect().top + window.scrollY - headerHeight;
        window.scrollTo({
          top: Math.max(0, top),
          behavior: root.dataset.motionEnabled === 'true' ? 'smooth' : 'auto',
        });
        mainNode.focus({ preventScroll: true });
      });
    }

    function setStage(stage, options) {
      state.stage = stateApi.normalizeStage(stage);
      if (options?.menu) state.menu = options.menu;
      if (options?.resetDraft) state.draft = null;
      syncUrl(options?.push !== false);
      const update = () => render();
      const transition = options?.animate !== false
        && root.dataset.motionEnabled === 'true'
        && typeof document.startViewTransition === 'function'
        ? document.startViewTransition(update)
        : null;
      if (options?.focus !== false) {
        if (transition) transition.finished.finally(focusStageStart);
        else focusStageStart();
      }
    }

    function setLocalAlert(groupKey, message) {
      window.clearTimeout(alertTimer);
      state.alerts = { [groupKey]: message };
      render();
      root.querySelector(`[data-allocation-group="${window.CSS.escape(groupKey)}"]`)?.focus();
      alertTimer = window.setTimeout(() => {
        state.alerts = {};
        render();
      }, 3800);
    }

    function showFeedback(message) {
      window.clearTimeout(feedbackTimer);
      feedbackNode.textContent = message;
      feedbackNode.hidden = false;
      feedbackNode.classList.remove('is-hiding');
      feedbackTimer = window.setTimeout(() => {
        feedbackNode.classList.add('is-hiding');
        window.setTimeout(() => { feedbackNode.hidden = true; }, 260);
      }, 4200);
    }

    function showIncompleteDialog(invalid) {
      pendingInvalidGroup = invalid.group.key;
      const message = invalid.validation.errors[0] || `Finish ${invalid.group.label}.`;
      incompleteEyebrowNode.textContent = copy.incompleteEyebrow;
      incompleteHeadingNode.textContent = copy.incompleteHeading;
      incompleteBodyNode.textContent = `${copy.incompleteBody} ${message}`;
      incompleteDialog.showModal();
      incompleteDialog.querySelector('[data-action="return-incomplete"]')?.focus();
    }

    function focusInvalidGroup() {
      if (!pendingInvalidGroup) return;
      const target = root.querySelector(`[data-allocation-group="${window.CSS.escape(pendingInvalidGroup)}"]`);
      pendingInvalidGroup = '';
      target?.scrollIntoView({ behavior: root.dataset.motionEnabled === 'true' ? 'smooth' : 'auto', block: 'start' });
      target?.focus({ preventScroll: true });
    }

    async function request(url, payload) {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: payload ? JSON.stringify(payload) : undefined,
      });
      const json = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(json.description || json.message || 'Shopify could not update this order.');
      return json;
    }

    async function refreshCart() {
      const response = await fetch(root.dataset.cartJsonUrl, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('The current cart could not be loaded.');
      state.cart = await response.json();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: state.cart }));
    }

    async function mutate(work) {
      if (state.busy) return;
      state.busy = true;
      render();
      try {
        await work();
        await refreshCart();
      } catch (error) {
        showFeedback(error.message || 'Shopify could not update this order.');
      } finally {
        state.busy = false;
        render();
      }
    }

    function journeyNeedsClear(concept) {
      if (!state.cart.items.length) return false;
      const existingConcept = cartConcept();
      const existingPack = packLine();
      if (existingConcept && existingConcept !== concept.handle) return true;
      return Boolean(existingPack && String(existingPack.variant_id) !== String(concept.pack.variantId));
    }

    function queueJourney(concept, stage) {
      if (!concept?.onlineOrderingEnabled) return;
      if (!journeyNeedsClear(concept)) {
        state.menu = concept.handle;
        setStage(stage, { resetDraft: state.draft?.concept !== concept.handle });
        return;
      }
      pendingReplace = { concept: concept.handle, stage };
      replaceItemsNode.innerHTML = state.cart.items.map((item) => `<li>${templates.escapeHtml(item.product_title || item.title)} &times; ${item.quantity}</li>`).join('');
      replaceDialog.showModal();
      replaceDialog.querySelector('[data-action="cancel-replace"]')?.focus();
    }

    function setGuests(value) {
      const concept = currentConcept();
      if (!concept) return;
      resizeDraft(ensureDraft(concept), concept, value);
      render();
    }

    function toggleDisposableWare(checked) {
      const concept = currentConcept();
      if (!concept) return;
      ensureDraft(concept).includeDisposableWare = Boolean(checked);
      render();
    }

    function toggleChoice(groupKey, option) {
      const concept = currentConcept();
      const draft = ensureDraft(concept);
      const group = concept.pack.choiceGroups.find((candidate) => candidate.key === groupKey);
      const groupState = draft.groups[groupKey];
      const requirements = rules.calculatePackRequirements(draft.guests, concept.pack.rule);
      const measure = groupKey === 'meat' ? requirements.meat : requirements.sides;
      if (groupState.selected.includes(option)) {
        groupState.selected = groupState.selected.filter((name) => name !== option);
        delete groupState.allocations[option];
      } else {
        if (groupState.selected.length >= measure.maximumSelections) {
          setLocalAlert(groupKey, `Choose no more than ${measure.maximumSelections} ${groupKey === 'meat' ? 'meats' : 'sides'} for ${draft.guests} guests.`);
          return;
        }
        groupState.selected.push(option);
      }
      groupState.allocations = rules.balancedAllocations(groupState.selected, measure.quantity, measure.step, measure.minimumPerOption);
      groupState.manuallyAdjusted = false;
      state.alerts = {};
      render();
    }

    function setAllocation(groupKey, option, requested) {
      const concept = currentConcept();
      const draft = ensureDraft(concept);
      const groupState = draft.groups[groupKey];
      if (!groupState?.selected.includes(option)) return;
      const requirements = rules.calculatePackRequirements(draft.guests, concept.pack.rule);
      const measure = groupKey === 'meat' ? requirements.meat : requirements.sides;
      if (Number(requested) <= 0) {
        const next = rules.removeAllocation(
          groupState.selected,
          option,
          measure.quantity,
          measure.step,
          measure.minimumPerOption,
          groupState.allocations,
        );
        groupState.selected = next.selected;
        groupState.allocations = next.allocations;
        groupState.manuallyAdjusted = true;
        render();
        return;
      }
      const others = groupState.selected.filter((name) => name !== option);
      if (!others.length) {
        groupState.allocations = { [option]: measure.quantity };
        render();
        return;
      }
      const maximum = measure.quantity - (others.length * measure.minimumPerOption);
      const stepped = Math.round(Number(requested) / measure.step) * measure.step;
      const fixed = Math.max(measure.minimumPerOption, Math.min(maximum, stepped));
      const remaining = measure.quantity - fixed;
      const resized = rules.resizeAllocations(others, remaining, measure.step, measure.minimumPerOption, groupState.allocations);
      groupState.allocations = { ...resized, [option]: fixed };
      groupState.manuallyAdjusted = true;
      render();
    }

    function validateDraft() {
      const concept = currentConcept();
      const draft = ensureDraft(concept);
      const requirements = rules.calculatePackRequirements(draft.guests, concept.pack.rule);
      for (const group of concept.pack.choiceGroups) {
        const groupState = draft.groups[group.key];
        const measure = group.key === 'meat' ? requirements.meat : requirements.sides;
        const validation = rules.validateAllocations(groupState.selected, groupState.allocations, measure.quantity, measure.step, measure.minimumPerOption, measure.maximumSelections);
        if (!validation.valid) return { group, validation };
      }
      return null;
    }

    function packProperties(existingProperties) {
      const concept = currentConcept();
      const draft = ensureDraft(concept);
      const requirements = rules.calculatePackRequirements(draft.guests, concept.pack.rule);
      const meat = draft.groups.meat || { selected: [], allocations: {} };
      const sides = draft.groups.side || { selected: [], allocations: {} };
      return stateApi.buildPackProperties({
        guests: draft.guests,
        concept: concept.handle,
        meat: { ...meat, unit: requirements.meat.unit },
        sides: { ...sides, unit: requirements.sides.unit },
        includedSauce: rules.formatVolume(requirements.sauce.quantity),
        includedBread: rules.formatBread(requirements.bread),
        includeDisposableWare: draft.includeDisposableWare,
        disposableWarePacks: rules.disposableWarePacks(draft.guests),
        existingProperties,
      });
    }

    async function normalizeLegacyPackLine(concept, item) {
      if (!concept || !item) return;
      const sidePortions = String(item.properties?.[stateApi.PUBLIC_PROPERTIES.sidePortions] || '');
      const requirements = rules.calculatePackRequirements(state.draft.guests, concept.pack.rule);
      const usesLegacyPints = requirements.sides.unit !== 'pt' && /\b(?:pt|pints?)\b/i.test(sidePortions);
      if (!usesLegacyPints) return;

      await request(root.dataset.cartChangeUrl, {
        id: item.key,
        quantity: state.draft.guests,
        properties: packProperties(item.properties),
      });
      await refreshCart();
      const refreshedLine = packLine();
      if (refreshedLine) state.draft = createDraft(concept, refreshedLine);
    }

    async function savePack() {
      const invalid = validateDraft();
      if (invalid) {
        showIncompleteDialog(invalid);
        return;
      }
      const concept = currentConcept();
      const draft = ensureDraft(concept);
      await mutate(async () => {
        const existing = packLine();
        if (existing) {
          await request(root.dataset.cartChangeUrl, { id: existing.key, quantity: draft.guests, properties: packProperties(existing.properties) });
        } else {
          await request(root.dataset.cartAddUrl, { items: [{ id: concept.pack.variantId, quantity: draft.guests, properties: packProperties() }] });
        }
        state.stage = 'addons';
        syncUrl(true);
      });
      focusStageStart();
    }

    async function addVariant(variantId, quantity) {
      const concept = currentConcept();
      const requestedQuantity = Math.max(1, Number.parseInt(quantity, 10) || 1);
      const existing = lineByVariant().get(String(variantId));
      await mutate(() => existing
        ? request(root.dataset.cartChangeUrl, { id: existing.key, quantity: Number(existing.quantity || 0) + requestedQuantity })
        : request(root.dataset.cartAddUrl, {
          items: [{
            id: variantId,
            quantity: requestedQuantity,
            properties: stateApi.buildAlaCarteProperties(concept.handle, Date.now()),
          }],
        }));
    }

    async function addAlaCarte(productKey) {
      const product = resolvedVirtualProducts(currentConcept()).find((candidate) => candidate.key === productKey);
      if (!product?.variantId) return;
      await addVariant(product.variantId, product.quantity);
      state.addonSelections[product.key] = {
        variantId: product.requiresSize ? '' : product.variantId,
        quantity: 1,
      };
      render();
    }

    async function addCategory(categoryKey) {
      const selection = state.categorySelections[categoryKey];
      if (!selection?.variantId) return;
      await addVariant(selection.variantId, selection.quantity);
      state.categorySelections[categoryKey] = { itemKey: '', variantId: '', quantity: 1 };
      render();
    }

    function setAlaCarteVariant(productKey, variantId) {
      const product = resolvedVirtualProducts(currentConcept()).find((candidate) => candidate.key === productKey);
      if (!product || !product.variants.some((variant) => variant.id === String(variantId))) return;
      state.addonSelections[product.key].variantId = String(variantId);
      render();
    }

    function setAddonQuantity(productKey, quantity) {
      const product = resolvedVirtualProducts(currentConcept()).find((candidate) => candidate.key === productKey);
      if (!product) return;
      state.addonSelections[product.key].quantity = Math.max(1, Number.parseInt(quantity, 10) || 1);
      render();
    }

    function setCategoryItem(categoryKey, itemKey) {
      const selection = state.categorySelections[categoryKey];
      if (!selection) return;
      const item = resolvedVirtualProducts(currentConcept())
        .find((candidate) => candidate.groupKey === categoryKey && candidate.key === itemKey);
      selection.itemKey = item?.key || '';
      selection.variantId = '';
      render();
    }

    function setCategoryVariant(categoryKey, variantId) {
      const selection = state.categorySelections[categoryKey];
      const item = resolvedVirtualProducts(currentConcept()).find((candidate) => candidate.key === selection?.itemKey);
      if (!selection || !item?.variants.some((variant) => variant.id === String(variantId))) return;
      selection.variantId = String(variantId);
      render();
    }

    function setCategoryQuantity(categoryKey, quantity) {
      const selection = state.categorySelections[categoryKey];
      if (!selection) return;
      selection.quantity = Math.max(1, Number.parseInt(quantity, 10) || 1);
      render();
    }

    async function changeLine(key, quantity) {
      await mutate(() => request(root.dataset.cartChangeUrl, { id: key, quantity: Number(quantity) }));
      if (!packLine()) state.draft = null;
    }

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-action]');
      if (!trigger || !root.contains(trigger)) return;
      const action = trigger.dataset.action;
      if (action === 'toggle-disposable-ware') return;
      if (action === 'checkout' && trigger.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
        showFeedback(checkoutState().message);
        return;
      }
      if (action !== 'checkout') event.preventDefault();
      if (action === 'start-concept') queueJourney(conceptByHandle(trigger.dataset.concept), 'configure');
      else if (action === 'browse-ala-carte') queueJourney(conceptByHandle(trigger.dataset.concept), 'ala-carte');
      else if (action === 'show-catalog') setStage('catalog');
      else if (action === 'show-configure') setStage('configure');
      else if (action === 'show-ala-carte') setStage(packLine() ? 'addons' : 'ala-carte');
      else if (action === 'adjust-guests') setGuests(ensureDraft(currentConcept()).guests + Number(trigger.dataset.delta));
      else if (action === 'toggle-choice') toggleChoice(trigger.dataset.group, trigger.dataset.option);
      else if (action === 'adjust-allocation') {
        const groupState = ensureDraft(currentConcept()).groups[trigger.dataset.group];
        setAllocation(trigger.dataset.group, trigger.dataset.option, Number(groupState.allocations[trigger.dataset.option] || 0) + Number(trigger.dataset.delta));
      } else if (action === 'save-pack') savePack();
      else if (action === 'add-ala') addAlaCarte(trigger.dataset.product);
      else if (action === 'add-category') addCategory(trigger.dataset.category);
      else if (action === 'adjust-addon-quantity') {
        const selection = state.addonSelections[trigger.dataset.product];
        setAddonQuantity(trigger.dataset.product, Number(selection?.quantity || 1) + Number(trigger.dataset.delta));
      } else if (action === 'adjust-category-quantity') {
        const selection = state.categorySelections[trigger.dataset.category];
        setCategoryQuantity(trigger.dataset.category, Number(selection?.quantity || 1) + Number(trigger.dataset.delta));
      }
      else if (action === 'change-line') changeLine(trigger.dataset.lineKey, trigger.dataset.quantity);
      else if (action === 'open-order-drawer') setMobilePanelState('half-open');
      else if (action === 'expand-order-drawer') {
        if (drawerDragged) drawerDragged = false;
        else setMobilePanelState(mobilePanelState === 'expanded' ? 'half-open' : 'expanded');
      } else if (action === 'collapse-order-drawer') setMobilePanelState('collapsed', { returnFocus: true });
      else if (action === 'open-booking') {
        if (!bookingDialog) return;
        if (window.CateringBookingDialog) window.CateringBookingDialog.open(bookingDialog, trigger);
        else bookingDialog.showModal();
      } else if (action === 'close-booking-dialog') bookingDialog?.close();
      else if (action === 'return-incomplete') {
        incompleteDialog.close();
        focusInvalidGroup();
      }
      else if (action === 'cancel-replace') {
        pendingReplace = null;
        replaceDialog.close();
      } else if (action === 'confirm-replace' && pendingReplace) {
        const next = pendingReplace;
        pendingReplace = null;
        replaceDialog.close();
        void mutate(async () => {
          await request(root.dataset.cartClearUrl);
          state.menu = next.concept;
          state.draft = null;
          state.stage = next.stage;
          syncUrl(true);
        }).then(focusStageStart);
      }
    });

    root.addEventListener('change', (event) => {
      const control = event.target.closest('[data-action]');
      if (!control || !root.contains(control)) return;
      if (control.dataset.action === 'set-guests') setGuests(control.value);
      if (control.dataset.action === 'toggle-disposable-ware') toggleDisposableWare(control.checked);
      if (control.dataset.action === 'set-allocation') setAllocation(control.dataset.group, control.dataset.option, control.value);
      if (control.dataset.action === 'set-addon-variant') setAlaCarteVariant(control.dataset.product, control.value);
      if (control.dataset.action === 'set-addon-quantity') setAddonQuantity(control.dataset.product, control.value);
      if (control.dataset.action === 'set-category-item') setCategoryItem(control.dataset.category, control.value);
      if (control.dataset.action === 'set-category-variant') setCategoryVariant(control.dataset.category, control.value);
      if (control.dataset.action === 'set-category-quantity') setCategoryQuantity(control.dataset.category, control.value);
    });

    window.addEventListener('popstate', () => {
      const url = new URL(window.location.href);
      state.stage = stateApi.normalizeStage(url.searchParams.get('stage'));
      state.menu = url.searchParams.get('menu') || state.menu;
      render();
      focusStageStart();
    });

    window.addEventListener('resize', syncMobileSummaryVisibility);

    drawerNode?.addEventListener('pointerdown', beginDrawerGesture);
    drawerNode?.addEventListener('pointermove', moveDrawerGesture);
    drawerNode?.addEventListener('pointerup', finishDrawerGesture);
    drawerNode?.addEventListener('pointercancel', finishDrawerGesture);

    [replaceDialog, bookingDialog].filter(Boolean).forEach((dialog) => {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });

    drawerNode?.addEventListener('click', (event) => {
      if (event.target === drawerNode) setMobilePanelState('collapsed', { returnFocus: true });
    });

    drawerNode?.addEventListener('cancel', (event) => {
      event.preventDefault();
      setMobilePanelState('collapsed', { returnFocus: true });
    });

    drawerNode?.addEventListener('close', () => {
      mobilePanelState = 'collapsed';
      drawerNode.dataset.mobilePanelState = 'collapsed';
      drawerNode.classList.remove('is-closing');
      syncMobilePanelControls();
    });

    incompleteDialog?.addEventListener('cancel', () => {
      window.setTimeout(focusInvalidGroup, 0);
    });

    refreshCart()
      .then(async () => {
        const existingConcept = cartConcept();
        if (!state.menu && existingConcept) state.menu = existingConcept;
        const concept = currentConcept();
        const existingPack = packLine();
        if (concept && existingPack) {
          state.draft = createDraft(concept, existingPack);
          await normalizeLegacyPackLine(concept, existingPack);
        }
        syncUrl(false);
        render();
      })
      .catch((error) => {
        showFeedback(error.message);
        render();
      });
  }
})();
